import { clamp, mean, type Index } from '@balansa/shared';

export const strDots = (s: number) => '●'.repeat(s) + '○'.repeat(3 - s);

export const SUGG = {
  give: ['naudu', 'enerģiju', 'laiku', 'atbalstu', 'prieku', 'motivāciju', 'iedvesmu', 'mieru'],
  take: ['laiku', 'enerģiju', 'naudu', 'miegu', 'uzmanību', 'spēkus', 'mieru']
};

export const NEED_BOTH = 'Izvēlies abas jomas.';

/** Kāpēc saiti starp šīm jomām nevar izveidot (tukša virkne — var). */
export function linkProblem(idx: Index, f: string | null | undefined, t: string | null | undefined) {
  if (!f || !t) return NEED_BOTH;
  if (f === t) return 'Joma nevar mijiedarboties pati ar sevi.';
  if (!idx.node.has(f) || !idx.node.has(t)) return NEED_BOTH;
  if (idx.anc.get(t)!.includes(f) || idx.anc.get(f)!.includes(t))
    return 'Saite starp jomu un tās pašas apakšjomu nav vajadzīga — virsjomas vērtību jau veido apakšjomas.';
  return '';
}

/** Lapu (apakšjomu) vērtības — priekšskatījumam, kā mainītos aplis. */
export function leafValues(idx: Index) {
  const m = new Map<string, number>();
  idx.node.forEach((n, id) => {
    if (!idx.kids.get(id)!.length) m.set(id, n.value);
  });
  return m;
}

export function valueFrom(idx: Index, id: string, lm: Map<string, number>): number {
  const k = idx.kids.get(id)!;
  return k.length ? mean(k.map((x) => valueFrom(idx, x, lm))) : clamp(lm.get(id) ?? 0, 0, 10);
}

export const parentPath = (idx: Index, id: string) =>
  idx.anc
    .get(id)!
    .slice(1)
    .reverse()
    .map((x) => idx.node.get(x)!.name)
    .join(' › ');

export const browserTz = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Riga';
  } catch {
    return 'Europe/Riga';
  }
};
